import ZJApi from './api'
import utils from '../../utils'

const info = {
    service: 'SendSmsService',
    controller: 'SendRecord'
}
const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'GeItemById',
    'FindByConditions',
    'GetPageContentByConditions',
    'SendSms'
]

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
}

const SendSmsApi = ZJApi.defineNewApi('SendSmsApi', factory)

export default SendSmsApi